import React from 'react';
import '../../App.css';
import '../Button.css';
import Cards from '../Cards';
export default function Products() {
  
  return (
    <>
      <Cards />
    </>
  );
}
